export enum EarlyPayoutAcceptance {
    Any = 'AcceptAnyChanges',
    Higher = 'AcceptHigherPayoutAmount',
}

export enum AccountMenuVersion {
    V3 = 3,
}

export enum CashoutIndicatorType {
    NoCashoutIndicator = 'NoCashoutIndicator',
    AdditionalInfo = 'AdditionalInfo',
    Brackets = 'Brackets',
    Arrow = 'Arrow',
}
